package one.healthium.carnivore

import kotlin.String

internal object BuildKonfig {
  public val BUILD_FLAVOUR: String = "Prod"
}
